  <section id="digital">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="digital-title">
            <span class="red">CAR</span>DATA DIGITAL
          </div>
        </div>
        <div class="col-md-4">
          <div class="digital-widget">
            <div class="digital-widget-body">
              <img src="assets/img/shared/bip.png" alt="" class="mt10">
              <p class="info">
                Cardata 2.El Fiyatlandırma
                uygulaması artık Turkcell BIP de
              </p>
            </div>
            <div class="digital-widget-footer">
              <a href="https://www.turkcell.com.tr/servisler/BiP" target="_blank" class="clearfix">
                Turkcell BIP <i class="sprite icon-rightarrow"></i>
              </a>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="digital-widget">
            <div class="digital-widget-body">
              <img src="assets/img/shared/digital1.png" alt="">
            </div>
            <div class="digital-widget-footer">
              <a href="https://dergilik.com.tr/magazine/45694" target="_blank">
                2.EL Otomobil Fiyat Rehberi <i class="sprite icon-rightarrow"></i>
              </a>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="digital-widget">
            <div class="digital-widget-body">
              <img src="assets/img/shared/digital2.png" alt="">
            </div>
            <div class="digital-widget-footer">
              <a href="https://dergilik.com.tr/magazine/38256" target="_blank" class="clearfix">
                0 KM Otomobil Fiyat Rehberi <i class="sprite icon-rightarrow"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>